.import-table-header {
    padding: 8px;
    height: 48px;
    align-content: center;
    background-color: var(--grey);
}
